import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/declarations',
    name: 'Declaration',
    component: {
      name: 'AdminDeclaration',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'declaration',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminDeclarationIndex',
        component: () => import('../views/admin/DeclarationsAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminDeclarationShow',
        component: () => import('../views/admin/DeclarationAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminDeclarationIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminDeclarationDetails',
            component: () => import('../views/admin/DeclarationAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminDeclarationIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminDeclarationEdit',
            component: () => import('../views/admin/DeclarationAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminDeclarationDetails' },
            },
          },
          {
            path: 'phases',
            name: 'AdmiDeclarationPhases',
            component: () => import('../views/admin/DeclarationAdminPhases.vue'),
            meta: {
              backRoute: { name: 'AdminDeclarationIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminDeclarationLogs',
            component: () => import('../views/admin/DeclarationAdminLogs.vue'),
            meta: {
              backRoute: { name: 'AdminDeclarationIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'user/declarations',
    name: 'UserDeclaration',
    component: {
      name: 'UserDeclaration',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'declaration',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserDeclarationIndex',
        component: () => import('../views/user/DeclarationsUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'UserDeclarationNew',
        component: () => import('../views/user/DeclarationUserInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'UserDeclarationIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserDeclarationShow',
        component: () => import('../views/user/DeclarationUserShow.vue'),
        meta: {
          backRoute: {
            name: 'UserDeclarationIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserDeclarationDetails',
            component: () => import('../views/user/DeclarationUserDetails.vue'),
            meta: {
              backRoute: { name: 'UserDeclarationIndex' },
            },
          },
          {
            path: 'edit',
            name: 'UserDeclarationEdit',
            component: () => import('../views/user/DeclarationUserInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'UserDeclarationDetails' },
            },
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));